import { createSimpleCache, CreateSimpleCacheOptions } from 'app/shared/lib/cache/create-simple-cache';
import { Sorting } from 'app/shared/lib/essette-site';
import type * as Core from 'app/core/models/essette-api';

export interface ICorrespondenceCacheState {
    memberId?: string;
    targetId?: string;
    moduleCode?: string;
    memberCultureId?: string | null;
    refreshChildren?: boolean;

    // dropdowns
    letterTemplates: ReadonlyArray<Core.CorrespondenceTemplate>;
    letterStatuses: ReadonlyArray<Core.CorrespondenceLetterStatus>;

    // pending letters
    letters: ReadonlyArray<Core.CorrespondenceLetter>;
    lettersPage?: number;
    lettersSorting?: Sorting;
    lettersResultCount?: number;

    // correspondence history
    letterHistories: ReadonlyArray<Core.CorrespondenceLetter>;
    letterHistoriesPage?: number;
    letterHistoriesSorting?: Sorting;
    letterHistoriesResultCount?: number;
}

export const createCorrespondenceCache = (opts: CreateSimpleCacheOptions<ICorrespondenceCacheState>) => createSimpleCache<ICorrespondenceCacheState>({ letters: [], letterHistories: [], letterStatuses: [], letterTemplates: [] }, opts);

export type ICorrespondenceCache = ReturnType<typeof createCorrespondenceCache>;
